import { useRef } from "react";
import type { ReactNode } from "react";
import ConfirmationPopover from "@/appComponents/Blocks/Composites/ConfirmationPopover/ConfirmationPopover";
import { Text, Tooltip } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

type ConfirmDeleteButtonProps = {
  onSubmit: () => void;
  tooltipMessage: string;
  headerTitle: string;
  children: ReactNode;
  triggerTestId?: string;
  dataTestPrefix?: string;
  placement?: string;
};

export const ConfirmDeleteButton = ({
  onSubmit,
  tooltipMessage,
  headerTitle,
  children,
  triggerTestId,
  dataTestPrefix,
  placement = "left-end"
}: ConfirmDeleteButtonProps) => {
  const openCtrlRef = useRef(null);

  return (
    <Tooltip message={tooltipMessage} referenceOpenCtrlRef={openCtrlRef}>
      <ConfirmationPopover
        openCtrlRef={openCtrlRef}
        onSubmit={onSubmit}
        icon="trash-can"
        color="error"
        iconOnly
        iconProps={{ size: "small" }}
        otherHeaderProps={{ title: headerTitle }}
        confirmLabel={appstr("Delete")}
        triggerTestId={triggerTestId}
        dataTestPrefix={dataTestPrefix}
        placement={placement}
      >
        <Text>{children}</Text>
      </ConfirmationPopover>
    </Tooltip>
  );
};
